import classes from "./GNCMacronutrientTips.module.css";

const TIPS = [
  {
    color: "var(--secondary20)",
    label: "Protein:",
    text: "Prioritize high-purity, hydrolyzed or 100% isolate protein sources with low sugar for rapid absorption, an optimal metabolic response, and superior body composition support.",
  },
  {
    color: "var(--secondary50)",
    label: "Smart Carbs:",
    text: "Choose complex, fiber-rich carbohydrates — oats, sweet potatoes, quinoa, and vegetables — over simple sugars for sustained energy and stable blood glucose.",
  },
  {
    color: "var(--secondary40)",
    label: "Healthy Fats:",
    text: "Include healthy fats from avocados, nuts, seeds, and olive oil to support hormonal balance, cellular function, and long-term cardiovascular health.",
  },
];

const GNCMacronutrientTips = () => {
  return (
    <div className={classes.container}>
      {TIPS.map((tip) => (
        <div className={classes.tipRow} key={tip.label}>
          <div className={classes.dot} style={{ backgroundColor: tip.color }} />
          <div className={classes.tipText}>
            <span className={classes.tipLabel} style={{ color: tip.color }}>
              {tip.label}
            </span>{" "}
            {tip.text}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GNCMacronutrientTips;
